import React from 'react';
import { Mail, Globe, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="py-8 px-4 bg-slate-900 text-white" data-id="element-91">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-92">
        <div className="mb-8" data-id="element-93">
          <span className="text-emerald-400 font-black tracking-widest text-sm uppercase" data-id="element-94">
            BIOLOGÍA EN ACCIÓN™ — Guía Digital 360
          </span>
          <p className="text-slate-400 text-xs mt-2 font-bold uppercase tracking-tighter" data-id="element-95">
            © {new Date().getFullYear()} BIOLOGÍA EN ACCIÓN™
          </p>
        </div>

        <div className="flex gap-6 mb-8" data-id="element-96">
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-97">
            <Instagram size={20} data-id="element-98" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-99">
            <Mail size={20} data-id="element-100" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-101">
            <Globe size={20} data-id="element-102" />
          </a>
        </div>

        <div className="space-y-2 text-[10px] md:text-xs text-slate-500 font-medium max-w-md" data-id="element-103">
          <p data-id="element-104">
            Aviso importante: El material es de carácter pedagógico y didáctico.
            Cada docente debe seleccionarlo y adaptarlo al programa educativo de
            su institución y a las necesidades de sus estudiantes.
          </p>
        </div>
      </div>
    </footer>;
}